<template>
  <div>
    <input
      :disabled="disabled"
      class="form-control"
      v-bind="$attrs"
      v-focus="focus"
      v-on:blur="changevalonblur"
      @keydown.enter.prevent="nextField()"
      ref="input"
      v-model="Internalvalue"
    />
  </div>
</template>
<script>
import { util } from 'pevueglobal'
export default {
  name: 'XVinput',

  props: {
    focus: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    value: {
      type: Number
    },
    formdata: {},
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Internalvalue: ''
    }
  },
  mounted() {
    if (this.value === null) {
      this.Internalvalue = ''
    } else {
      this.Internalvalue = new Intl.NumberFormat(util.GetCulture()).format(this.value)
    }
  },
  methods: {
    changevalonblur: function() {
      if (this.Internalvalue === '') {
        this.$emit('input', null)
        this.$emit('formvaluechanged', {
          type: this.$vnode.componentOptions.tag,
          value: null,
          id: this.id,
          formdata: this.formdata
        })
      } else {
        var nr = this.Internalvalue
        nr = nr.toString().replace(',', '.')
        nr = Number(nr)
        this.$emit('input', nr)
        this.$emit('formvaluechanged', {
          type: this.$vnode.componentOptions.tag,
          value: nr,
          id: this.id,
          formdata: this.formdata
        })
      }
    },
    nextField: function() {
      if (this.$refs.input.form) {
        for (let i = 0; i < this.$refs.input.form.elements.length; i++) {
          if (this.$refs.input.form.elements[i].tabIndex === this.$refs.input.tabIndex + 1) {
            this.$refs.input.form.elements[i].focus()
            if (this.$refs.input.form.elements[i].type === 'text') {
              this.$refs.input.form.elements[i].select()
            }
          }
        }
      }
    }
  }
}
</script>
